export default {
  title: "Astana CRM"
};
